const config = {
  API_URL: process.env.REACT_APP_API_URL || "https://dev-api.codigocerebro.com.mx/api/",
};

export default config;
